import React, { useState } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { ProblemSolution } from './components/ProblemSolution';
import { Workflow } from './components/Workflow';
import { OutputShowcase } from './components/OutputShowcase';
import { ConsistencySection } from './components/ConsistencySection';
import { RealOutputDemo } from './components/RealOutputDemo';
import { FeatureGrid } from './components/FeatureGrid';
import { AIDisclosure } from './components/AIDisclosure';
import { PlansSection } from './components/PlansSection';
import { PrivateBetaSection } from './components/PrivateBetaSection';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { WaitlistModal } from './components/WaitlistModal';
import { LegalModal, LegalDocType } from './components/LegalModal';

export const App: React.FC = () => {
  const [waitlistOpen, setWaitlistOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState<string | undefined>(undefined);
  const [legalDoc, setLegalDoc] = useState<LegalDocType>(null);

  const handleOpenWaitlist = (plan?: string) => {
    setSelectedPlan(plan);
    setWaitlistOpen(true);
  };

  const handleOpenLegal = (type: NonNullable<LegalDocType>) => {
    setLegalDoc(type);
  };

  return (
    <div className="min-h-screen bg-brand-bg text-brand-text flex flex-col selection:bg-brand-primary selection:text-white">
      {/* Top Navbar */}
      <Navbar onOpenWaitlist={() => handleOpenWaitlist()} />

      {/* Main Page Content */}
      <main className="flex-1">
        {/* 1. Hero Section */}
        <Hero onOpenWaitlist={() => handleOpenWaitlist()} />

        {/* 2. Problem vs Solution */}
        <ProblemSolution />

        {/* 3. Factual Workflow / 8-Stage Pipeline */}
        <Workflow />

        {/* 4. Certified Output Showcase */}
        <OutputShowcase />

        {/* 5. Architectural Consistency */}
        <ConsistencySection />

        {/* 6. Real Laboratory Output Demo */}
        <RealOutputDemo />

        {/* 7. Platform Feature Grid */}
        <FeatureGrid />

        {/* 8. Ethical AI Disclosure */}
        <AIDisclosure />

        {/* 9. Plans & Credit Allocations */}
        <PlansSection onOpenWaitlist={(plan) => handleOpenWaitlist(plan)} />

        {/* 10. Private Beta Controlled Access */}
        <PrivateBetaSection onOpenWaitlist={() => handleOpenWaitlist()} />

        {/* 11. Frequently Asked Questions */}
        <FAQ />
      </main>

      {/* 12. Institutional Footer */}
      <Footer
        onOpenLegal={handleOpenLegal}
        onOpenWaitlist={() => handleOpenWaitlist()}
      />

      {/* Waitlist Modal Dialog */}
      <WaitlistModal
        isOpen={waitlistOpen}
        onClose={() => setWaitlistOpen(false)}
        initialPlan={selectedPlan}
        onOpenLegal={(type) => {
          setWaitlistOpen(false);
          setLegalDoc(type);
        }}
      />

      {/* Legal Documents Modal Dialog */}
      <LegalModal
        type={legalDoc}
        onClose={() => setLegalDoc(null)}
      />
    </div>
  );
};

export default App;
